/* unplugin-vue-components disabled */import script from "./MarketPropsEditCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketPropsEditCard.vue?vue&type=script&setup=true&lang=js"

import "./MarketPropsEditCard.vue?vue&type=style&index=0&id=23bf92e8&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23bf92e8"]])

export default __exports__